import createApp from '@/utils/create-app'
import AppComponent from './app/App.vue'
import { routesProviders, storesProviders, pluginsRunners } from '@/v-shop/autoloader'

export default function ({ ssrContext, window, errorHandler }) {
	return createApp({
		ssrContext,
		window,
		AppComponent,
		routesProviders,
		storesProviders,
		pluginsRunners,
		errorHandler,
	})
}

